import { render, staticRenderFns } from "./OtrDevices.vue?vue&type=template&id=68246361"
import script from "./OtrDevices.vue?vue&type=script&lang=js"
export * from "./OtrDevices.vue?vue&type=script&lang=js"
import style0 from "./OtrDevices.vue?vue&type=style&index=0&id=68246361&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports